import React from 'react'
export const BaseLayoutContext = React.createContext([{}, (topMenu) => topMenu])
